import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconWarningSign({
  extColor,
  isAutoscallable = true,
  sizeKey = '20x20',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.error.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 20 20"
      fill={fill}
    >
      <path d="M9.99935 4.24643L16.5829 15.6211H3.41583L9.99935 4.24643ZM1.90328 14.7468C1.23006 15.9097 2.06939 17.3698 3.41583 17.3698H16.5829C17.9293 17.3698 18.7686 15.9097 18.0954 14.7468L11.5119 3.37212C10.8387 2.20929 9.16002 2.20929 8.4868 3.37212L1.90328 14.7468ZM9.12504 8.6267V10.3753C9.12504 10.8562 9.51848 11.2496 9.99935 11.2496C10.4802 11.2496 10.8737 10.8562 10.8737 10.3753V8.6267C10.8737 8.14583 10.4802 7.75239 9.99935 7.75239C9.51848 7.75239 9.12504 8.14583 9.12504 8.6267ZM9.12504 12.9982H10.8737V14.7468H9.12504V12.9982Z" />
    </svg>
  );
}
